import { themeChanger as setTheme } from '../../../hooks/useTheme/theme-changer'
import { useTab } from '../../../hooks/'

declare let window: MondrianReact;

interface MondrianReact extends Window {
  MondrianReact: {
    setTheme: any;
    useTab: any;
    version: string
  };
}

try {
  if (typeof window !== 'undefined') {
    window.MondrianReact = {
      setTheme: setTheme,
      useTab: useTab,
      version: '4.20.7'
    }
  }
} catch (err) {
  console.log(`Warning! Window object not founded.
     SeTheme will not be set globally.
     \nHint:If you want to use setTheme, use withs imports.`)
}


export default setTheme
